import { GriddleStoreFront } from "./GriddleStoreFront";
import { v4 as uuidv4 } from "uuid";
import { diContainer } from "@smartsheet/cufflink";
import { ConfigSettingsUtil } from "../util/ConfigSettingsUtil";
import { LogActionId, loggingStateServiceKey } from "@smartsheet/logging-state-service";
import { initializeLoggingService } from "./Logger";
import logger from "./Logger";
import { FLAG_ID_ENABLE_GRID_STATE_BROKER, LOG_ID_CONTROL_GENERIC, LOG_ID_PERF_API } from "./constants";
var Griddle = /** @class */ (function () {
    function Griddle(config) {
        var _this = this;
        Griddle.config = Object.freeze(config);
        this.loggingService = diContainer.get(loggingStateServiceKey.name);
        initializeLoggingService(this.loggingService);
        var storeFront = new GriddleStoreFront();
        var throwIfBrokerIsDisabled = function () {
            ConfigSettingsUtil.throwIfConfigSettingBooleanIsFalse(FLAG_ID_ENABLE_GRID_STATE_BROKER);
        };
        // Broker implementation encapsulates gridId and other client information
        this.getBroker = function (brokerArgs) {
            // In terms of feature flagging - it is simpler to throw an exception here if the feature
            // is disabled. The feature is manifest by adding a new function (getBroker) to gridStateService
            // and it feels sloppy and brittle to have a property of the gridStateService
            // either be a function or undefined based on a configSetting.
            throwIfBrokerIsDisabled();
            var gridId = brokerArgs.gridId;
            var brokerId = uuidv4();
            if (isNaN(brokerArgs.gridId) || gridId < 0) {
                throw Error("A valid gridId must be provided");
            }
            var subscription;
            var createAction = function (actionType, args) {
                return {
                    actionId: uuidv4(),
                    gridId: gridId,
                    type: actionType,
                    payload: args
                };
            };
            var execute = function (actionType) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                var startTime = performance.now();
                var results = storeFront.executeAction(createAction(actionType, args));
                logger.logTelemetryWithoutPrivateInfo(LOG_ID_CONTROL_GENERIC, LogActionId.DIAGNOSTIC, LOG_ID_PERF_API, undefined, new Map([
                    ["gridID", gridId],
                    ["actionType", actionType],
                    ["elapsedMs", performance.now() - startTime]
                ]));
                return results;
            };
            var gridAPI = {
                getInfo: function () {
                    return execute(1 /* GETINFO */);
                }
            };
            var cellAPI = {
                getByCoords: function (coords) {
                    return execute(3000 /* GETBYCOORDS */, coords);
                },
                getMapByCoords: function (coords) {
                    return execute(3001 /* GETMAPBYCOORDS */, coords);
                },
                setText: function (coords, text) {
                    return execute(3002 /* SETTEXT */, coords, text);
                },
                setNumber: function (coords, numeric) {
                    return execute(3003 /* SETNUMBER */, coords, numeric);
                }
            };
            var rowAPI = {
                getOrder: function () {
                    return execute(1000 /* GETORDER */);
                },
                getById: function (ids) {
                    return execute(1001 /* GETBYID */, ids);
                },
                getStructure: function () {
                    return execute(1002 /* GETSTRUCTURE */);
                }
            };
            var columnAPI = {
                getOrder: function () {
                    return execute(2000 /* GETORDER */);
                },
                getById: function (ids) {
                    return execute(2001 /* GETBYID */, ids);
                },
                getAll: function () {
                    return execute(2002 /* GETALL */);
                },
                getOptionsById: function (ids) {
                    return execute(2003 /* GETOPTIONSBYID */, ids);
                }
            };
            return Object.freeze({
                subscribe: function (callBack) {
                    return (subscription = subscription !== null && subscription !== void 0 ? subscription : storeFront.subscribe(_this, gridId, callBack));
                },
                unsubscribe: function () {
                    if (subscription) {
                        subscription.unsubscribe();
                        subscription = undefined;
                    }
                },
                GRID: gridAPI,
                CELL: cellAPI,
                ROW: rowAPI,
                COLUMN: columnAPI
            });
        };
        this.getDevBroker = function () {
            return {
                killAllSubscriptions: function () {
                    // helper method
                }
            };
        };
    }
    return Griddle;
}());
export { Griddle };
//# sourceMappingURL=Griddle.js.map